import { render } from "./NewRegisterWithCode.vue?vue&type=template&id=dbfe2346&scoped=true"
import script from "./NewRegisterWithCode.vue?vue&type=script&lang=js"
export * from "./NewRegisterWithCode.vue?vue&type=script&lang=js"

import "./NewRegisterWithCode.vue?vue&type=style&index=0&id=dbfe2346&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbfe2346"]])

export default __exports__